export default __webpack_public_path__ + "static/media/sideimg.5e6877f3.jpg";